/* dataLayer-Events für die Akkordeons der Produktseite.
   Ein Push pro Öffnen, mit dem Namen des geöffneten Elements.
   Capture-Phase, damit der Zustand vor dem Klick gelesen wird. */
(function () {
  var EVENTS = {
    detail: 'Product_detail_open',
    function: 'product_function_open',
    faq: 'faq_open',
  };

  function push(event, summaryEl) {
    var name = (summaryEl.textContent || '').replace(/\s+/g, ' ').trim();
    if (!name) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event, accordion_name: name });
  }

  document.addEventListener(
    'click',
    function (e) {
      var toggle = e.target.closest('[data-ivt-toggle]');
      if (toggle) {
        if (toggle.getAttribute('aria-expanded') !== 'true') {
          push(EVENTS.function, toggle.querySelector('.ivt__title') || toggle);
        }
        return;
      }

      var summary = e.target.closest('summary');
      var details = summary && summary.closest('details[is="accordion-group"]');
      if (!details || details.open) return;

      if (details.closest('.section-main-product')) {
        push(EVENTS.detail, summary.querySelector('h2') || summary);
      } else if (details.closest('collapsible-tabs')) {
        push(EVENTS.faq, summary.querySelector('h2') || summary);
      }
    },
    true
  );
})();
